const contactPage = $('#contactForm').length;

export function contactFunc() {
  if (contactPage) {
    const typeSelect = $("[name='type']");
    let selectIndex = '';

    const formField = $('#formField');
    // セレクタを使用して 'type' 属性が 'text' の input 要素を取得
    var textInputs = $("input[type='text']");
    var emailInputs = $("input[type='email']");
    var telInputs = $("input[type='tel']");
    var textareaInputs = $("textarea");

    function formResetFunc(){
      textInputs.val('');
      emailInputs.val('');
      telInputs.val('');
      textareaInputs.val('');
      $("input[type='checkbox']").prop('checked', false);
      $("input[type='radio']:not([name='type'])").prop('checked', false);
      $(".contactFormField .error").removeClass("error");
      $(".errorTxt").text("");
    }

    var radioButtons = $("input[name='type']");
    // 問い合わせ種別の選択時に入力データをリセットする
    radioButtons.on("click", function() {
      formResetFunc();
    });

    // お問い合わせ種別
    const selectControl = function () {
      for (var val = "", i = typeSelect.length; i--;) {
        if (typeSelect[i].checked) {
          var val = typeSelect[i].value;
          break;
        }
      }
      selectIndex = val;
      if (selectIndex != '') {
        if (selectIndex == 'job') {
          $('#job').addClass('isShow');
        } else {
          formField.addClass('isShow');
          if (selectIndex == 'business') {
            $('#business').addClass('isShow');
            $('.business').addClass('isShow');
            $("#proposal").show();
            $("#otherRequest").show();
            $("#proposalDetail").hide();
          } else if(selectIndex == 'proposal'){
            $('#business').addClass('isShow');
            $('.proposal').addClass('isShow');
            $("#proposal").hide();
            $("#proposalDetail").show();
            $("#otherRequest").hide();
          }else {
            $('#basic').addClass('isShow');
            if (selectIndex == 'online') {
              $('.online').addClass('isShow');
            } else if (selectIndex == 'product') {
              $('.product').addClass('isShow');
            } else if (selectIndex == 'inferior') {
              $('.inferior').addClass('isShow');
            } else if (selectIndex == 'interview') {
              $('.interview').addClass('isShow');
            } else if (selectIndex == 'other') {
              $('.other').addClass('isShow');
            }
          }
        }
      }
    }

    // 必須項目名
    const companyName = $("[name='companyName']");
    const mediaName = $("[name='mediaName']");
    const contactName = $("[name='contactName']");
    const myName = $("[name='myName']");
    const email = $("[name='email']");
    const emailCheck = $("[name='emailCheck']");
    const telNumber = $("[name='telNumber']");
    const subject = $("[name='subject']");
    const product = $("[name='product']");
    const content = $("[name='content']");
    const postalCode = $("[name='postalCode']");
    const otherRequest = $("[name='otherRequest']");
    const proposalDetail = $("[name='proposalDetail']");
    const agreeCheck = $("[name='agreeCheck']");

    const businessCompanyName = $("[name='businessCompanyName']");
    const representativeName = $("[name='representativeName']");
    const yearMonth = $("[name='yearMonth']");
    const capital = $("[name='capital']");
    const employeeNum = $("[name='employeeNum']");
    const tradingCompany = $("[name='tradingCompany']");
    const annualSales = $("[name='annualSales']");
    const companySite = $("[name='companySite']");
    const representTelNumber = $("[name='representTelNumber']");
    const businessContactName = $("[name='businessContactName']");
    const companyTelNumber = $("[name='companyTelNumber']");
    const companyAddress = $("[name='companyAddress']");
    const companyEmail = $("[name='companyEmail']");
    const companyEmailCheck = $("[name='companyEmailCheck']");
    const tradingPlans = $("[name='tradingPlans']");
    const tradingCountry = $("[name='tradingCountry']");
    const salesForms = $("[name='salesForms']");
    const salesChannel = $("[name='salesChannel']");
    const tradingProducts = $("[name='tradingProducts']");
    const monthlySales = $("[name='monthlySales']");

    // 必須項目定義
    const onlineRequired = [myName, email, emailCheck, telNumber, subject, content, agreeCheck];
    const productRequired = [myName, email, emailCheck, telNumber, product, content, agreeCheck];
    const inferiorRequired = [myName, email, emailCheck, telNumber, product, content, agreeCheck];
    const interviewRequired = [companyName, mediaName, contactName, email, emailCheck, telNumber, content, agreeCheck];
    const otherRequired = [myName, email, emailCheck, telNumber, content, agreeCheck];
    const businessRequired = [businessCompanyName, representativeName, yearMonth, capital, employeeNum, tradingCompany, annualSales, companySite, representTelNumber, companyAddress, businessContactName, companyTelNumber, companyEmail, companyEmailCheck, salesChannel, monthlySales, agreeCheck];
    const proposalRequired = [businessCompanyName, representativeName, yearMonth, capital, employeeNum, tradingCompany, annualSales, companySite, representTelNumber, companyAddress, businessContactName, companyTelNumber, companyEmail, companyEmailCheck, agreeCheck];

    // 必須項目設定
    let requiredField = [];
    const requiredFieldSet = function () {
      switch (selectIndex) {
        case 'online':
          requiredField = onlineRequired;
          break;
        case 'product':
          requiredField = productRequired;
          break;
        case 'inferior':
          requiredField = inferiorRequired;
          break;
        case 'business':
          requiredField = businessRequired;
          break;
        case 'proposal':
          requiredField = proposalRequired;
          break;
        case 'interview':
          requiredField = interviewRequired;
          break;
        case 'other':
          requiredField = otherRequired;
          break;
      }
      for (let i = 0; i < requiredField.length; i++) {
        let requiredFieldType = requiredField[i].attr('type');
        if (requiredFieldType == 'radio' || requiredFieldType == 'checkbox') {
          requiredField[i].change(function () {
            fieldCheck(requiredField[i]);
          });
        } else {
          requiredField[i].blur(function () {
            fieldCheck(requiredField[i]);
          });
        }
      }
    }

    // リロード時実行
    selectControl();
    requiredFieldSet();

    // セレクト選択時実行
    typeSelect.change(function () {
      formField.removeClass('isShow');
      $('.split').removeClass('isShow');
      selectIndex = typeSelect.val();
      selectControl();
      requiredFieldSet();
    });

    const agreeCheckTxt = '「プライバシーポリシーに同意する」にチェックをしてください';
    const emailRequiredTxt = '正しいメールアドレスを入力してください';
    const emailDuplication = '上記フォームで入力したメールアドレスと異なります';
    const telRequiredTxt = '10桁〜12桁の数字を入力してください';

    let errorTxt = '';
    const fieldCheck = function (checkField, all = false) {
      let checkFieldValue = checkField.val();
      let checkFieldType = checkField.attr('type');
      let checkFieldTag = checkField[0].tagName;
      let checkFieldName = checkField.attr('name');
      let checkFieldLabel = $('[for= ' + checkFieldName + ']');
      console.log(checkFieldLabel)
      let checkFieldLabelTxt = checkFieldLabel.text().replace("※必須", "");
      if (checkFieldType == 'radio') {
        errorTxt = checkFieldLabelTxt + 'は選択必須です';
        if (!checkField.is(':checked')) {
          checkField.parents('.radioArea').addClass('error').next('.errorTxt').text(errorTxt);
        } else {
          checkField.parents('.radioArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField == agreeCheck) {
        if (!checkField.is(':checked')) {
          checkField.parents('.checkboxArea').addClass('error').next('.errorTxt').text(agreeCheckTxt);
        } else {
          checkField.parents('.checkboxArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField.hasClass('select')) {
        errorTxt = checkFieldLabelTxt + 'は選択必須です';
        if (checkFieldValue == '') {
          checkField.addClass('error').parent('.selectBtn').next('.errorTxt').text(errorTxt);
        } else {
          checkField.removeClass('error').parent('.selectBtn').next('.errorTxt').text('');
        }
      } else {
        errorTxt = checkFieldLabelTxt + 'は入力必須です';
        if (checkFieldName == 'content' && selectIndex != 'inferior') {
          errorTxt = 'お問い合わせ内容は入力必須です';
        }
        if (checkFieldValue == '') {
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } else if (checkFieldType == 'email' && !checkFieldValue.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
          checkField.addClass('error').next('.errorTxt').text(emailRequiredTxt);
        } else if (checkField == emailCheck && checkFieldValue != email.val()) {
          checkField.addClass('error').next('.errorTxt').text(emailDuplication);
        } else if (checkField == companyEmailCheck && checkFieldValue != companyEmail.val()) {
          checkField.addClass('error').next('.errorTxt').text(emailDuplication);
        }else if (checkFieldType == 'tel' && !checkFieldValue.match('^[0-9]{10,12}$')) {
          checkField.addClass('error').next('.errorTxt').text(telRequiredTxt);
        } else if (checkFieldTag == 'TEXTAREA' && checkFieldValue.length >= 501) {
          errorTxt = '500文字以内で入力してください';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } else {
          checkField.removeClass('error').next('.errorTxt').text('');
        }
      }
    };

    otherRequest.blur(function () {
      if (otherRequest.val().length >= 501) {
        errorTxt = '500文字以内で入力してください';
        otherRequest.addClass('error').next('.errorTxt').text(errorTxt);
      } else {
        otherRequest.removeClass('error').next('.errorTxt').text('');
      }
    });

    proposalDetail.blur(function () {
      if (proposalDetail.val().length >= 501) {
        errorTxt = '500文字以内で入力してください';
        proposalDetail.addClass('error').next('.errorTxt').text(errorTxt);
      } else {
        proposalDetail.removeClass('error').next('.errorTxt').text('');
      }
    });

    $('.attachedDocument').on('change', function(){
      //許可するタイプのリスト .jpg / .png / .pdf / .doc / .docx / .xls / .xlsx / .txt / .zip /.ppt / .pptx
      var acceptArray = new Array('image/jpeg','image/png','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/plain','application/zip','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation');
      var formatArray = new RegExp('([^\s]+(\\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|txt|zip|ppt|pptx))$)', 'i');
      var limitSize = 10 * 1024 * 1024; //10MB

      const file = $(this).prop('files')[0];
      errorTxt = '添付資料はアップロードできない形式です';
      let errorTxt2 = '添付できるファイルの容量は10MBまでです';

      if(file){
        const fileName = $(this).prop('files')[0].name;
        const fileType = $(this).prop('files')[0].type;
        const fileSize = $(this).prop('files')[0].size;

        if(!fileName.match(formatArray)){
          $(this).parents('.attachedDocumentBox').addClass('error').next('.errorTxt').text(errorTxt);
          $(this).val('');
        }else if($.inArray(fileType, acceptArray) === -1){
          $(this).parents('.attachedDocumentBox').addClass('error').next('.errorTxt').text(errorTxt);
          $(this).val('');
        }else if(fileSize > limitSize){
          $(this).parents('.attachedDocumentBox').addClass('error').next('.errorTxt').text(errorTxt2);
          $(this).val('');
        }else{
          $(this).parents('.attachedDocumentBox').removeClass('error').next('.errorTxt').text('');
        }
      }
    });

    $('.tradingCountry').on('change', function(){
      if (selectIndex == 'business') {
        var r = $('.tradingCountry:checked').length > 0;
        errorTxt = '販売予定国は選択必須です';

        if(r){
          $(this).parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $(this).parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }
      }
  });
  
  $('.tradingPlans').on('change', function(){
      if (selectIndex == 'business') {
        var r = $('.tradingPlans:checked').length > 0;
        errorTxt = '希望取引は選択必須です';

        if(r){
          $(this).parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $(this).parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }
      }
  });

  $('.salesForms').on('change', function(){
      if (selectIndex == 'business') {
        var r = $('.salesForms:checked').length > 0;
        errorTxt = '販売形態は選択必須です';

        if(r){
          $(this).parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $(this).parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }
      }
  });

  $('.tradingProducts').on('change', function(){
      if (selectIndex == 'business') {
        var r = $('.tradingProducts:checked').length > 0;
        errorTxt = '取引希望製品は選択必須です';

        if(r){
          $(this).parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $(this).parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }
      }
  });

  function is_checked(){
    if (selectIndex == 'business') {
        var cnt = 0;
        cnt += $('.tradingProducts:checked').length;
        errorTxt = '取引希望製品は選択必須です';
  
        if(cnt > 0){
          $('.tradingProducts').parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $('.tradingProducts').parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }

        var cnt = 0;
        cnt += $('.tradingCountry:checked').length;
        errorTxt = '販売予定国は選択必須です';
  
        if(cnt > 0){
          $('.tradingCountry').parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $('.tradingCountry').parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }

        var cnt = 0;
        cnt += $('.tradingPlans:checked').length;
        errorTxt = '希望取引は選択必須です';
  
        if(cnt > 0){
          $('.tradingPlans').parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $('.tradingPlans').parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }

        var cnt = 0;
        cnt += $('.salesForms:checked').length;
        errorTxt = '販売形態は選択必須です';
  
        if(cnt > 0){
          $('.salesForms').parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }else{
          $('.salesForms').parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        }
        
        return cnt;
    }
  }
    let sendBtn = $('#sendBtn');
    // 各項目をサブミット処理でチェック（個人、法人フォーム）
    $('form').submit(function (e) {
      // 初期設定
      let set = 0;
      if (set == 0) {
        set = 1;
      } else {
        return false;
      }

      // 各項目をチェック（個人フォーム用）
      for (let i = 0; i < requiredField.length; i++) {
        fieldCheck(requiredField[i]);
      }

      is_checked();

      // エラー箇所があればその場所までスクロール
      let offsetTxt, headerHeight;
      if ($('.errorTxt').text() != '') {
        offsetTxt = $('.error').offset().top;
        headerHeight = $('#header').outerHeight();
        $('html,body').animate({
          scrollTop: offsetTxt - headerHeight
        }, 500);
        return false;
      }
      

      // エラーがなければ二重送信禁止
      sendBtn.prop('disabled', 'true');
      setTimeout(function () {
        sendBtn.prop('disabled', '');
      }, 1000);
      return true;
    });

    // ラジオボタンチェック時入力欄有効可
    const radioBtn = document.querySelectorAll('.radioBtn');
    const radioField = document.querySelectorAll('.radioField');
    for (let i = 0; i < radioBtn.length; i++) {
      if (radioBtn[i].checked) {
        radioField[i].disabled = false;
      } else {
        radioField[i].disabled = true;
      }
    }
    $("input[type='radio']").on('click', function () {
      for (let i = 0; i < radioBtn.length; i++) {
        if (radioBtn[i].checked) {
          radioField[i].disabled = false;
        } else {
          radioField[i].disabled = true;
          radioField[i].value = '';
        }
      }
    });

    // チェックボックスチェック時入力欄有効可
    const checkBtn = document.querySelectorAll('.checkBtn');
    const checkField = document.querySelectorAll('.checkField');
    for (let i = 0; i < checkBtn.length; i++) {
      if (checkBtn[i].checked) {
        checkField[i].disabled = true;
        checkField[i].value = '';
      } else {
        checkField[i].disabled = false;
      }
    }
    $("input[type='checkbox']").on('click', function () {
      for (let i = 0; i < checkBtn.length; i++) {
        if (checkBtn[i].checked) {
          checkField[i].disabled = true;
          checkField[i].value = '';
        } else {
          checkField[i].disabled = false;
        }
      }
    });

    // チェックボックスチェック時入力欄有効可
    const checkBtn02 = document.querySelectorAll('.checkBtn02');
    const checkField02 = document.querySelectorAll('.checkField02');
    for (let i = 0; i < checkBtn02.length; i++) {
      if (checkBtn02[i].checked) {
        checkField02[i].disabled = false;
      } else {
        checkField02[i].disabled = true;
        checkField02[i].value = '';
      }
    }
    $(".checkboxArea02 .checkBtn02").on('click', function () {
      for (let i = 0; i < checkBtn02.length; i++) {
        if (checkBtn02[i].checked) {
          checkField02[i].disabled = false;
        } else {
          checkField02[i].disabled = true;
          checkField02[i].value = '';
        }
      }
    });

    //添付ファイル
    document.querySelector(".attachedDocumentBtn").addEventListener("click", () => {
      document.querySelector(".attachedDocument").click();

      var selectedFiles = document.querySelector(".attachedDocument").files;
      if(selectedFiles.length == 0){
        $('.attachedDocumentTxt').removeClass('active').text('選択してください。');
        $('.attachedDocumentReset').val('0');
        $('.attachedDocument').val('');
      }
    });

    //ファイル名を表示する
    $('.attachedDocument').on('change', function(){
      let attachedDocumentName;
      let attachedDocumentFile = $(this).prop('files')[0];

      if(attachedDocumentFile && $(this)[0].files.length > 0){
        attachedDocumentName = $(this).prop('files')[0].name;
        if(attachedDocumentName){
          $('.attachedDocumentTxt').addClass('active').text(attachedDocumentName);
          $('.attachedDocumentReset').val('1');
        }
      } else{
        $('.attachedDocumentTxt').removeClass('active').text('選択してください。');
        $('.attachedDocumentReset').val('0');
      }
    });
  }
}
